import { useDispatch } from "react-redux";
import Share from "../../../assets/images/Share.png";
import path from "../../../assets/images/logo.svg";
import Logo from "../../atoms/logo";

import { logout } from "../../../redux/auth";
import { Link } from "react-router-dom";
import { Container } from "./styles";

const DashboardHeader = () => {
  const dispatch = useDispatch();
  function logOut(): void {
    dispatch(logout());
  }

  return (
    <Container>
      <div>
        <Link to="/">
          <Logo src={path} />
        </Link>
      </div>
      <div className="visit" onClick={logOut}>
        <h2>Log out </h2>
        <div className=" w-[1.1em] ">
          <img src={Share} alt="" className="w-[100%] h-[100%] object-contain " />
        </div>
      </div>
    </Container>
  );
};

export default DashboardHeader;
